/*global FormController, Decimal*/


var depositPopupController = new FormController("account_move", 
    {
        directory: "views/deposit",
        name: "refundOutstandingPopup",
        route: "refund-outstanding-popup",
        buttonsHTML: "<!-- no button -->",
        openInPopup: true,
        noTitle: true,
        defaultData: { },
        popup: {
            size: "medium"
        }
    }
);
/**
 * Add sale settings
 */
depositPopupController.prepareDataOnEnter = function(creditMoveId, callback){
    this.api.db.account_move_line.searchFirst({id: creditMoveId}, [
        {otherTable: "account_move", name: "move"}
    ], function(err, creditMoveLine){
        if(err){ return callback(err) ;}
        var data = {} ;
        data.payment_date = new Date();
        data.creditMoveLine = creditMoveLine;
        callback(null, data) ;
    }) ;
} ;

depositPopupController.onChangeMode = function(ev){
    if(ev.data === "read"){
        this.setMode("create") ;
    }
} ;

depositPopupController.getRecordsToSave = function(viewData, dataBeforeModif, callback){
    this.api.db.multiread({
        account_journal: { searchFirst: { id: viewData.journal_id}, joinFetch: [
            { otherTable: "account_account", otherField: "id", thisField: "default_debit_account_id", name: "account"}
        ] }
    }, function(err, reads){
        if(err){ return callback(err) ;}
        var records = [] ;

        var date = new Date() ;
        var amount = Math.abs(this.data.creditMoveLine.amount_residual) ;

        records.push({
            table: "account_move",
            action: "insert",
            record: {
                name: "Refund "+this.data.creditMoveLine.move.name,
                amount : Math.abs(this.data.creditMoveLine.amount_residual),
                ref : this.data.creditMoveLine.move.name,
                journal_id : viewData.journal_id,
                partner_id : this.data.creditMoveLine.move.partner_id,
                state : "posted",
                date : viewData.payment_date,
            }
        }) ;

        records.push({
            table: "account_move_line",
            action: "insert",
            record: {
                move_id: "${account_move.id}",
                account_id : reads.account_journal.account.id,
                date_maturity : date,
                date : date,
                user_type_id: reads.account_journal.account.user_type_id,
                partner_id : this.data.creditMoveLine.partner_id,
                amount_residual : 0,
                debit : 0,
                debit_cash_basis : 0,
                credit : amount,
                credit_cash_basis :amount ,
                balance_cash_basis : new Decimal(-1).mul(amount).toNumber(),
                balance : new Decimal(-1).mul(amount).toNumber(),
                name : this.data.creditMoveLine.name,
                reconciled : false, 
                journal_id : viewData.journal_id,
                ref : this.data.creditMoveLine.ref
            }
        }) ;

        records.push({
            table: "account_move_line",
            action: "insert",
            record: {
                move_id: "${account_move.id}",
                account_id : this.data.creditMoveLine.account_id,
                date_maturity : viewData.payment_date,
                date : viewData.payment_date,
                user_type_id: this.data.creditMoveLine.user_type_id,
                partner_id : this.data.creditMoveLine.partner_id,
                amount_residual : amount,
                debit : amount,
                debit_cash_basis : amount,
                credit : 0,
                credit_cash_basis : 0,
                balance_cash_basis : amount,
                balance : amount,
                name : this.data.creditMoveLine.name,
                reconciled : false, 
                journal_id : viewData.journal_id,
                ref :  this.data.creditMoveLine.ref,
            }
        }) ;

        records.push({
            table: "account_partial_reconcile",
            action: "insert",
            record :{
                debit_move_id: "${account_move_line.id}",
                credit_move_id: this.data.creditMoveLine.id,
                company_id: this.data.creditMoveLine.company_id,
                amount: amount,
                amount_currency: 0,
                max_date: new Date(),
            }
        }) ;

        callback(null, records) ;
    }.bind(this));
};

depositPopupController.onClose = function(){
    this.mode = 'read' ; //avoid abort input warning
};
depositPopupController.onCancel = function(){
    this.view.close() ;
};
depositPopupController.onValidate = function(){
    this.view.longTask(function(done){
        this.doValidate(function(err, savedRecord){
            if(err){ return done(err); }
            if(!savedRecord){
                //check failed
                return done() ;
            }
            this.mode = 'read' ; //avoid abort input warning
            this.view.close() ;
            done() ;
        }.bind(this)) ;
    }.bind(this)) ;
};



module.exports = depositPopupController ;